<template>
  <div class="layout--tags">
    <div class="tags--group">
      <p class="tags--group__title">Tags</p>
      <div class="tags--group__layout">
        <label
          v-for="tag in tagsList"
          :key="tag.id"
          class="atm--checkbox"
          :class="tagHasBeenSelected(tag) && 'checked'"
        >
          <input
            type="checkbox"
            :checked="tagHasBeenSelected(tag)"
            @change="() => toggleTagSelection(tag)"
            class="atm--checkbox__input"
          />
          <div class="d-flex align-items-center">
            <span class="material-icons small" :style="{ color: tag.color }">
              {{ tag.icon || defaultIcon}}
            </span>
            <span class="atm--checkbox__text">
              {{ tag.name }}
            </span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tagsList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tagSelected: null,
      defaultIcon: 'lens',
    };
  },
  methods: {
    tagHasBeenSelected(tag) {
      return this.tagSelected && this.tagSelected.id === tag.id;
    },
    toggleTagSelection(tag) {
      if (this.tagHasBeenSelected(tag)) {
        this.tagSelected = null;
      } else {
        this.tagSelected = tag;
      }
      this.tagSelectedEmit(tag);
    },
    tagSelectedEmit(tag) {
      const tagSelected = this.tagHasBeenSelected(tag) ? tag : null;
      this.$emit('tag-selected', tagSelected);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout--tags {
  display: grid;
  gap: 1rem;

  .tags--group {
    &__title {
      font-weight: bold;
      text-transform: capitalize;
    }
    &__layout {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
}

.atm--checkbox {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 8px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  box-shadow: 1px 1px 8px #ccc;

  &__input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  &__text {
    padding: 0 8px;
  }
}
.checked {
  background: var(--color-main) ;
  color: white ;
}
</style>
